import { render, staticRenderFns } from "./LicenceAssign.vue?vue&type=template&id=6ff6011f"
import script from "./LicenceAssign.vue?vue&type=script&lang=ts"
export * from "./LicenceAssign.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports